import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useAddProductToFavoritesMutation = createMutationHook(
  ProductCatalogApiClient.addProductToFavorite,
  {
    mutationKey: ['addProductToFavorites'],
  },
)
